import PropTypes from 'prop-types';
import React from 'react';
import Modal from 'react-modal';
import Input from '../../pages/travellersDetails/components/TravellerContactInfo/FormFields/Input';
import {
  getItemBySession,
  itemType
} from 'MMT-UI/storages/client/sessionStorage';
import '../../pages/travellersDetails/components/IrctcLoginModals/LoginModals.css';
import { isValidMobile } from '../../constants/Validators';
import queryString from 'query-string';
import { RAIL_CAPTCHA_PATH } from '../../constants/URLconstants';
import { STORAGE_CONSTANTS } from '../../constants/TrainConstants';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

class RetrievePassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: true,
      disabled: true,
      rotate: false,
      validationFail: false,
      mobileNumber: '',
      userId: null,
      errorMessage: '',
    };
  }

  componentWillMount() {
    const userId = getItemBySession(
      STORAGE_CONSTANTS.VERIFIED_USER_ID,
      { isPiiData: true, shouldParseJson: true },
      itemType.ES
    );

    this.setState({
      userId,
    });
  }

  componentWillUnmount() {
    if (this._dismissAnimTimer) {
      clearTimeout(this._dismissAnimTimer);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.forgotDetails.error) {
      if (nextProps.forgotDetails.error.includes('OTP')) {
        this.setState({
          errorMessage: 'You have sent too many password requests for this username.',
          validationFail: true,
        });
      } else {
        this.setState({
          errorMessage: 'This phone number and username are not linked.',
          validationFail: true,
        });
      }
    } else {
      this.goToNextPage();
    }
  }

  goToNextPage =() => {
    const queryParams = queryString.parse(this.props.location.search);
    if (queryParams.fromIrctcPage) {
      this.props.history.push(`${RAIL_CAPTCHA_PATH}/?mmtId=${queryParams.mmtId}`);
    } else {
      const checkoutUrl = JSON.parse(localStorage.getItem('checkoutURL'));
      window.location.assign(checkoutUrl);
    }
  };

  closeModal=() => {
    this.setState({
      showModal: false,
    });
    this.props.closeModal();
  };

  handleInputKeyUpViaParent=(val) => {
    this.setState({
      mobileNumber: val,
    });

    if (isValidMobile(val)) {
      this.setState({
        disabled: false,
      });
    } else {
      this.setState({
        disabled: true,
      });
    }
  };

  rotateLoader= () => {
    if (!this.state.disabled) {
      this.setState({
        rotate: true,
      });

      const queryParams = { mobile: this.state.mobileNumber,
        userLoginId: this.state.userId,
        otpType: 'M' };

      this.props.userForgotDetailsActionV2('P', queryParams);

      this._dismissAnimTimer = setTimeout(() => {
        this.setState({
          rotate: false,
        });
      }, 1500);
    } else {
      // do nothing
    }
  };

  render() {
    const { showModal, validationFail, disabled, rotate, userId, errorMessage, mobileNumber } = this.state;
    return (
      userId &&
      <Modal
        isOpen={showModal}
        ariaHideApp={false}
        onRequestClose={this.closeModal}
        className="loginModals htmlv2"
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        style={{
          overlay: {
            backgroundColor: 'rgb(0, 0, 0, 0.6)',
            zIndex: 1,
          },
          customStyles,
        }}
      >
        <div className="singlePanel">
          {/* <p className="textRight modalCloseCont">
            <span
              className="modalClose"
              onClick={this.closeModal}
            >
            X
            </span>
          </p> */}

          <p className="font20 latoBold darkGreyText appendBottom10">Reset IRCTC Password</p>
          <p className="font14 appendBottom30">Enter the mobile number registered with IRCTC username {userId} to get a new password via SMS.</p>

          <div className="appendBottom50 end">
            <div className={'makeFlex column appendRight2 appendBottom40 spaceBetween hrtlStart'}>
              <Input
                labelName="MOBILE NUMBER"
                errorMessage={errorMessage}
                validationFail={validationFail}
                type="text"
                additionalAttributes={{ placeholder: 'Enter Mobile Number' }}
                fieldId="IRCTCUserName"
                fieldName="IRCTCUserName"
                vaidationMsg=""
                vaidationMoreMsg=""
                vaidationMoreStatus={false}
                vaidationStatus
                readOnly={false}
                handleInputKeyUpViaParent={this.handleInputKeyUpViaParent}
                value={mobileNumber}
              />
            </div>

            <button
              onClick={this.rotateLoader}
              className={`${disabled ? 'disabled' : ''} noShrink width220`}
            >
              <span className={`${rotate ? 'btnLoader' : 'font12 latoBlack capText'}`}>Get Password on SMS</span>
            </button>
          </div>
          <p>
            <a className="font16 latoBold" onClick={this.goToNextPage}>GO BACK</a>
          </p>
        </div>
      </Modal>
    );
  }
}

RetrievePassword.propTypes = {
  forgotDetails: PropTypes.object,
  showModal: PropTypes.bool,
  switchModal: PropTypes.func,
  updateVerifiedUser: PropTypes.func,
  userForgotDetailsActionV2: PropTypes.func,
  userStatus: PropTypes.object,
};

export default RetrievePassword;
